var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{staticClass:"cls-1",attrs:{"d":"M1903.4,97.973l-4.44-4.468,1.46-1.5,6.58,7-6.58,7-1.43-1.567,4.54-4.437m-5.09-2.023L1894,93.5l1.45-1.5,6.59,7-6.59,7-1.42-1.567,4.53-4.437","transform":"translate(-1894 -92)"}})
}
var staticRenderFns = []

export { render, staticRenderFns }